<template>
  <div>
    <v-page-toolbar :title="routeName" :icon="iconName">
      <template v-slot:buttons>
        <v-spacer></v-spacer>

        <v-btn color="success" dark class="mb-2" @click="dialog = true">
          <v-icon dark left>add_circle_outline</v-icon>
          {{ $t("common.new").toLocaleUpperCase(lang) }}
          {{ routeName.toLocaleUpperCase(lang) }}
        </v-btn>
        <place-dialog-button
          :dialog.sync="dialog"
          :editedItem="newItem"
          :editedIndex="itemIndex"
          :counties="counties"
          :neighborhoods="neighborhoods"
          :routeName="routeName"
          :categoryId="routeId"
          @confirmed="onConfirmed"
          @cancelled="onCancelled"
        />
      </template>
    </v-page-toolbar>
    <v-layout row wrap fluid>
      <v-flex lg12>
        <place-table
          :filter.sync="filter"
          :groupId="routeId"
          :counties="counties"
          :neighborhoods="neighborhoods"
          @mapPlace="mapPlace"
          @mapRePlace="mapRePlace"
        />
      </v-flex>
    </v-layout>
    <VMap
      :categoryId="routeId"
      :showPoints="items"
      showType="places"
      :mapCenter.sync="center"
      :mapZoom.sync="zoom"
      :showPlaceInfo.sync="showDialog"
      :showPlaceCoord="placeCoord"
      :selectedPlace="selectedItem"
      :selectedAssets="selectedAssets"
      :selectedText="selectedText"
      :selectedTitle="selectedTitle"
    />
  </div>
</template>

<script>
import PlaceTable from "./PlaceTable";
import VMap from "@/components/ui/VMap.vue";
import PlaceDialogButton from "./PlaceDialogButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { PlaceTable, VMap, PlaceDialogButton },

  watch: {
    "$route.params.place": {
      handler: function (name) {
        this.routeName = name;
        this.showDialog = false;
      },
      deep: true,
      immediate: true,
    },
    "$route.params.id": {
      handler: function (id) {
        this.routeId = id;
        this.showDialog = false;
      },
      deep: true,
      immediate: true,
    },
    "$route.params.icon": {
      handler: function (icon) {
        this.iconName = icon;
        this.showDialog = false;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    const jwt = this.$store.getters["auth/jwtDecoded"];
    if (jwt.city_code === "59") {
      this.center = [27.511675, 40.978092];
      this.cityCenter = [27.511675, 40.978092];
    } else {
      this.center = [36.33534518345682, 41.295020754851635];
      this.cityCenter = [36.33534518345682, 41.295020754851635];
    }
    this.getCounties();
    this.getNeighborhoods();
    this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
  },

  data() {
    return {
      routeId: this.$route.params.id,
      routeName: this.$route.params.place,
      iconName: this.$route.params.icon,
      filter: {},
      emptyFilter: {
        name: "",
        cityCode: null,
        countyCode: null,
        categoryIds: [],
      },
      newItem: {
        id: "",
        name: "",
        address: "",
        countyCode: null,
        neighborhoodCode: "",
        phone: "",
        lat: "",
        lon: "",
      },
      dialog: false,
      itemIndex: -1,
      page: 0,
      totalItemsPerPage: 10000,
      places: null,
      center: [],
      cityCenter: [],
      zoom: 9,
      showDialog: false,
      placeCoord: [],
      selectedItem: null,
      overlay: true,
      selectedAssets: [],
      selectedTitle: "",
      selectedText: "",
    };
  },
  mounted() {
    if (this.icon) {
      this.iconName = this.icon;
    }
  },
  computed: {
    ...mapGetters({ counties: "cities/counties" }),
    ...mapGetters({ neighborhoods: "cities/neighborhoods" }),
    ...mapGetters({ items: "places/items" }),
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
  },
  methods: {
    ...mapActions(["cities/getCountiesByCity"]),
    ...mapActions(["cities/getNeighborhoodsByCity"]),
    ...mapActions(["places/getItems"]),

    async refreshTable() {
      console.log("after confirm");
      let filterr = JSON.parse(JSON.stringify(this.filter));

      filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("places/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
    },
    async getCounties() {
      await this.$store.dispatch("cities/getCountiesByCity");
      this.counties.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    async getNeighborhoods() {
      let filterr = JSON.parse(JSON.stringify(this.filter));
      await this.$store.dispatch("cities/getNeighborhoodsByCity", {
        page: 0,
        itemsPerPage: 2000,
        filter: filterr,
      });
      this.neighborhoods.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    onConfirmed(editedItem) {
      // hide a dialog
      console.log("confffffffffffffirmeddddd");
      this.dialog = false;
      this.refreshTable();
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    mapPlace(item) {
      console.log("son adım");
      this.center = [item.lon, item.lat];
      this.placeCoord = [item.lon, item.lat];
      this.zoom = 16;
      this.showDialog = true;
      this.selectedItem = item;
      this.selectedAssets = item.placeAssets;
      this.selectedTitle = item.name;
      this.selectedText = item.fullAddress;
    },
    mapRePlace() {
      this.center = this.cityCenter;
      this.zoom = 9;
      this.showDialog = false;
    },
  },
};
</script>
